export default __webpack_public_path__ + "static/media/Search.36ce4d3d.svg";